/**
 * Constantes de unidades de medida, massa e quantidade.
 * Fonte única de verdade para todos os formulários do sistema.
 */

export interface UnitOption {
    readonly value: string;
    readonly label: string;
}

/** Unidades de medida (comprimento, área, volume, capacidade) */
export const MEASURE_UNITS: readonly UnitOption[] = [
    { value: "mm", label: "Milímetro (mm)" },
    { value: "cm", label: "Centímetro (cm)" },
    { value: "m", label: "Metro (m)" },
    { value: "m2", label: "Metro Quadrado (m²)" },
    { value: "m3", label: "Metro Cúbico (m³)" },
    { value: "km", label: "Quilômetro (km)" },
    { value: "in", label: "Polegada (in)" },
    { value: "ft", label: "Pé (ft)" },
    { value: "l", label: "Litro (l)" },
    { value: "ml", label: "Mililitro (ml)" },
    { value: "gal", label: "Galão (gal)" },
] as const;

/** Unidades de massa */
export const MASS_UNITS: readonly UnitOption[] = [
    { value: "mg", label: "Miligrama (mg)" },
    { value: "g", label: "Grama (g)" },
    { value: "kg", label: "Quilograma (kg)" },
    { value: "t", label: "Tonelada (t)" },
    { value: "lb", label: "Libra (lb)" },
    { value: "oz", label: "Onça (oz)" },
] as const;

/** Unidades de quantidade */
export const QUANTITY_UNITS: readonly UnitOption[] = [
    { value: "un", label: "Unidade (un)" },
    { value: "cj", label: "Conjunto (cj)" },
    { value: "cx", label: "Caixa (cx)" },
    { value: "kit", label: "Kit (kit)" },
    { value: "pc", label: "Peça (pç)" },
    { value: "rl", label: "Rolo (rl)" },
    { value: "sc", label: "Saco (sc)" },
    { value: "par", label: "Par (par)" },
    { value: "lt", label: "Lata (lt)" },
    { value: "br", label: "Barra (br)" },
    { value: "fl", label: "Folha (fl)" },
] as const;

/** Unidades de custo (tempo, verba, etc) */
export const COST_UNITS: readonly UnitOption[] = [
    { value: "h", label: "Hora (h)" },
    { value: "d", label: "Dia (d)" },
    { value: "mes", label: "Mês (mês)" },
    { value: "dt", label: "Dia de Trabalho (dt)" },
    { value: "verb", label: "Verba (vb)" },
] as const;

/** Todas as unidades combinadas */
export const ALL_UNITS: readonly UnitOption[] = [
    ...MEASURE_UNITS,
    ...MASS_UNITS,
    ...QUANTITY_UNITS,
    ...COST_UNITS,
];
